import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import styled from "styled-components";
import { FlexColumn, FlexColumnDiv, FlexRowDiv } from "./common.styles";
import { mobilePageHPadding } from "./HXMobilePage.styles";
export const ClearTextContainer = styled(FlexColumnDiv) `
    gap: 24px;
    padding-top: 24px;
`;
export const ClearTitleContainer = styled(FlexColumnDiv) `
    gap: 8px;
`;
export const RowIcon = styled.img `
    width: 24px;
    height: 24px;
`;
export const RowTitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
    text-align: left;
    line-height: normal;
`;
export const RowText = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
    text-align: left;
    line-height: normal;
`;
export const RowStartIconAndNameContainer = styled(FlexRowDiv) `
    display: flex;
    align-items: center;
    gap: 8px;
    line-height: normal;
`;
export const RowTextContainer = styled(FlexColumnDiv) `
    display: flex;
    align-items: left;
    gap: 3px;
    line-height: normal;
`;
export const LoginFooterContainer = styled(FlexColumnDiv) `
    padding: 24px ${mobilePageHPadding}px;
    align-items: center;
    align-self: stretch;
    gap: 18px;
`;
export const ProgressContainer = styled.div `
    position: relative;
    width: 88px;
    height: 88px;
    align-self: center;
`;
export const ProgressRing = styled.svg `
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);

    circle {
        fill: none;
        stroke: #ff8a2d;
        stroke-width: 4;
        stroke-dasharray: ${(props) => {
    const radius = 42.5;
    const circumference = 2 * Math.PI * radius;
    const progress = (props.progress / 100) * circumference;
    return `${progress} ${circumference}`;
}};
        stroke-linecap: round;
        transition: ${(props) => (props.shouldAnimate ? `stroke-dasharray ${props.animationDuration}s linear` : "none")};
    }
`;
export const ProgressBackground = styled.div `
    position: absolute;
    inset: 8px;
    border-radius: 50%;
    background-color: ${colors.navy_main};
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const ClearLogo = styled.img `
    width: 48.889px;
    height: 48.889px;
`;
export const TextContentContainer = styled(FlexColumnDiv) `
    align-self: stretch;
    align-items: center;
    gap: 16px;
`;
export const LoadingTitle = styled.div `
    font-size: ${fontSizes.MOBILE_TITLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
    text-align: center;
    line-height: 36px;
`;
export const LoadingDescription = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
    text-align: center;
    letter-spacing: 0.15px;
    line-height: normal;
`;
export const DividerLine = styled.div `
    width: 100%;
    height: 1px;
    background-color: ${colors.black_lighter};
    opacity: 0.2;
`;
export const InfoBox = styled(FlexRowDiv) `
    align-self: stretch;
    background-color: ${colors.navy_8};
    border: 1px solid ${colors.navy_30};
    border-radius: 12px;
    padding: 12px 16px 12px 16px;
    align-items: center;
    gap: 16px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: ${colors.navy_12};
    }
`;
export const InfoBoxTextContainer = styled(FlexColumnDiv) `
    flex: 1;
    gap: 4px;
`;
export const InfoBoxTitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.BOLD};
    color: ${colors.navy_main};
    line-height: normal;
`;
export const InfoBoxDescription = styled.div `
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.navy_main};
    line-height: normal;
`;
export const InfoBoxIcon = styled.img `
    width: 24px;
    height: 24px;
    opacity: 0.7;
`;
export const LoadingFooterContainer = styled(FlexColumnDiv) `
    padding: 24px ${mobilePageHPadding}px;
    align-items: center;
    align-self: stretch;
`;
export const IdentityLoadingContainer = styled(FlexColumnDiv) `
    gap: 32px;
    align-items: center;
    align-self: center;
    width: 329px;
`;
export const HealthExTopLogo = styled.img `
    width: 100px;
    height: 20px;
    align-self: center;
    margin-top: 40px;
`;
export const IdentityProgressContainer = styled.div `
    position: relative;
    width: 88px;
    height: 88px;
    align-self: center;
`;
export const AnimatedProgressRing = styled.svg `
    position: absolute;
    inset: 0;
    width: 104px;
    height: 104px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) rotate(-90deg);

    circle {
        fill: none;
        stroke: ${colors.sunset_main};
        stroke-width: 3;
        stroke-dasharray: ${(props) => {
    const radius = 50.5;
    const circumference = 2 * Math.PI * radius;
    const progress = (props.progress / 100) * circumference;
    return `${progress} ${circumference}`;
}};
        stroke-linecap: round;
        transition: stroke-dasharray ${(props) => { var _a; return (_a = props.transitionDuration) !== null && _a !== void 0 ? _a : 1.2; }}s ease-in-out 0.1s;
    }
`;
export const ProgressBackgroundCircle = styled.div `
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 88px;
    height: 88px;
    border-radius: 50%;
    border: 1px solid rgba(29, 98, 174, 0.3);
    background: linear-gradient(135deg, #ffd881 0%, #ff8a2d 100%);
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const HealthExIconInProgress = styled.img `
    height: 29.33px;
    object-fit: cover;
`;
export const IdentityTextContainer = styled(FlexColumnDiv) `
    gap: 16px;
    align-items: center;
    text-align: center;
    width: 100%;
`;
export const IdentityVerifyingTitle = styled.div `
    font-size: ${fontSizes.MOBILE_TITLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
    line-height: 36px;
    width: 100%;
`;
export const IdentityVerifyingDescription = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
    letter-spacing: 0.15px;
    line-height: normal;
    width: 100%;
`;
export const ErrorContainer = styled(FlexColumn) `
    align-items: center;
    gap: 40px;
    padding-bottom: ${(props) => { var _a; return (_a = props.paddingBottom) !== null && _a !== void 0 ? _a : 0; }}px;
`;
export const ErrorLogoContainer = styled.div `
    width: 100px;
    height: 20px;
    align-self: center;
`;
export const ErrorLogo = styled.img `
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
export const ErrorContentContainer = styled(FlexColumnDiv) `
    width: 329px;
    align-items: center;
    gap: 32px;
`;
export const ErrorIconContainer = styled.div `
    position: relative;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background-color: ${colors.sunset_12};
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const ErrorIcon = styled.div `
    width: 40px;
    height: 40px;
    color: ${colors.sunset_main};
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 100%;
        height: 100%;
    }
`;
export const ErrorMessageContainer = styled(FlexColumnDiv) `
    align-self: stretch;
    align-items: center;
    gap: 24px;
`;
export const ErrorTextContainer = styled(FlexColumnDiv) `
    align-self: stretch;
    align-items: center;
    gap: 16px;
    text-align: center;
`;
export const ErrorTitle = styled.div `
    font-size: ${fontSizes.MOBILE_TITLE};
    font-weight: 500;
    color: ${colors.black_main};
    text-align: center;
    line-height: 36px;
    width: 100%;
`;
export const ErrorDescription = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_light};
    text-align: center;
    letter-spacing: 0.15px;
    line-height: normal;
    width: 100%;
`;
export const ErrorFooterContainer = styled(FlexColumnDiv) `
    padding: 24px ${mobilePageHPadding}px;
    align-items: center;
    align-self: stretch;
    gap: 12px;
`;
